import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { SdsComponent } from './sds.component';
import { ViewSdsComponent } from './shared/components/view-sds/view-sds.component';

@NgModule({
	declarations: [SdsComponent, ViewSdsComponent],
	imports: [CommonModule, SharedModule],
})
export class SdsModule {}
